export default {
    name: 'v5-icon-scan',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M234.667 640v149.333h159.978v64H234.667a64 64 0 01-64-64V640h64zm618.666 0v149.333a64 64 0 01-64 64H629.312v-64h160.021V640h64zM768 480v64H256v-64h512zm21.333-309.333a64 64 0 0164 64V384h-64V234.667h-160v-64h160zm-394.666 0v64h-160V384h-64V234.667a64 64 0 0164-64h160z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
